import { pascalCase } from "change-case";

import type { FileMediaAssetValue } from "@skilitics/designer-ui-components";
import type { NodeTemplateCategory, NodeTemplateScopeType } from "@skilitics/nautilus-endpoint-definition";

type Option<T = string> = { value: T; label: string };

const toPascalCaseOption = <T extends string = string>(value: T): Option<T> => ({
  value,
  label: pascalCase(value),
});

export const scopes = ["system", "user", "module"] as const satisfies NodeTemplateScopeType[];

export const scopeOptions = scopes.map(toPascalCaseOption);

export const categoriesToOptions = (categories: NodeTemplateCategory[]): Option[] =>
  categories.map(({ name, title }): Option => ({ value: name, label: title }));

export const addEmptyOption = (options: Option[], label = "Any"): Option[] => [{ value: "", label }, ...options];

// Need to mock a FileMediaAssetValue to match what the FieldImageAsset expects.
export const uploadedThumbnailAsset = (assetId: string): FileMediaAssetValue => ({
  source: "file",
  assetId,
  name: "",
});
